import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuthService } from './auth.service'; // Replace with the actual path to your authentication service

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        // Check for 401 Unauthorized response
        if (error.status === 401) {

          // Handle 401 error, e.g., navigate to login screen and display a Toast message
          this.authService.logout();
          this.router.navigate(['/intro']);

          // You can use your ToastService here to show the session expired message
          return throwError('Session expired');

        } else {
          return throwError(error);
        }
      })
    );
  }
}
